// eslint-disable-next-line import/no-self-import
import { isServer } from '@webapp/common/lib/const';

import { createBrowserHistory, createMemoryHistory } from 'history';
// eslint-disable-next-line import/no-self-import
import type { History } from 'history';

// TODO FIXME probably don't needed with next.js
export const history: History = isServer ? createMemoryHistory() : createBrowserHistory();
